/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum HousingIntakeScenarioLogType {
    SCENARIO_CREATED = 'ScenarioCreated',
    INTAKE_STARTED = 'IntakeStarted',
    INTAKE_CANCELLED = 'IntakeCancelled',
    NO_OFFER = 'NoOffer',
    OFFER_REJECTED = 'OfferRejected',
    OFFER_ACCEPTED = 'OfferAccepted',
    SCENARIO_CLOSED = 'ScenarioClosed',
    SCENARIO_ARCHIVED = 'ScenarioArchived',
    SCENARIO_UPDATED = 'ScenarioUpdated',
    LIST_GENERATED = 'ListGenerated',
    MAJOR_MISALIGNMENT = 'MajorMisalignment',
    APPLICATION_CANCELLED = 'ApplicationCancelled',
    OFFER_EXTENDED = 'OfferExtended',
    SCENARIO_MIGRATED = 'ScenarioMigrated',
    TEAM_MEMBER_ADDED = 'TeamMemberAdded',
    TEAM_MEMBER_REMOVED = 'TeamMemberRemoved',
    RETURNED_TO_WAITLIST = 'ReturnedToWaitlist',
    AUTO_UNLOCKED = 'AutoUnlocked',
}
